module.exports = __webpack_public_path__ + "img/logo-white.f7447b19.svg";